<template>
    <div class="condition">
        <div style="display: flex; justify-content: space-between; align-items: center; gap: 10px; margin-bottom: 10px;">

            <div style="display: flex; justify-content: flex-start; align-items: center; gap: 10px;">
                <div style="color: #ddd">└──</div>
                <input
                    v-if="condition.type !== 'group'"
                    type="text"
                    v-model="condition.name"
                    placeholder="Condition name"
                    style="width: 200px;"
                />


                <select v-model="condition.type" style="width: 120px;">
                    <option value="query">Query Params</option>
                    <option value="cookie">Cookie</option>
                    <option value="group"  :disabled="path.length === 2">Group</option>
                </select>

                <select
                    v-if="showOperator"
                    v-model="condition.operator"
                    style="width: 80px;"
                >
                    <option value="AND">AND</option>
                    <option value="OR">OR</option>
                </select>

            </div>
            <div class="flex-gap">
                <i
                    class="fal fa-indent"
                    @click="addChild"
                    v-if="path.length < 2"
                />
                <i class="fal fa-trash-alt" @click="emitDelete" />
            </div>
        </div>

        <div class="child-conditions" style="margin-left: 20px;">
            <ConditionNode
                v-for="(child, index) in condition.conditions"
                :key="index"
                :condition="child"
                :path="[...path, index]"
                :parent-index="parentIndex"
                :siblings-length="condition.conditions.length"
                :is-last="index === condition.conditions.length - 1"
                @delete="forwardDelete"
            />

        </div>
    </div>
</template>

<script>
export default {
    name: 'ConditionNode',
    props: {
        condition: Object,
        path: {
            type: Array,
            default: () => []
        },
        parentIndex: Number,
        isLast: {
            type: Boolean,
            default: false
        },
        siblingsLength: Number
    },
    methods: {
        addChild() {
            this.condition.conditions.push({ name: '', type: 'query', operator: 'AND', conditions: [] });
        },
        emitDelete() {
            const index = this.path[this.path.length - 1];
            const parentPath = this.path.slice(0, -1);
            this.$emit('delete', this.parentIndex, parentPath, index);
        },
        forwardDelete(parentIndex, path, index) {
            this.$emit('delete', parentIndex, path, index);
        }
    },
    computed: {
        showOperator() {
            const hasChildren = Array.isArray(this.condition.conditions) && this.condition.conditions.length > 0;
            const myIndex = this.path[this.path.length - 1];
            const isLast = myIndex === this.siblingsLength - 1;

            // Mostra la select se ha figli o se non è l'ultimo del suo livello
            return !isLast;
        }
    },

    watch: {
        showOperator(val) {
            if (!val && this.condition.operator) {
                this.condition.operator = '';
            }
            if (val && !this.condition.operator) {
                this.condition.operator = 'AND'; // opzionale
            }
        }
    }






};
</script>

